import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'

import {
  getDateFormatted,
  useRouteState,
  getLocalStorageItem,
} from '@shared/utils'

import { ConfirmationModalRouteState } from './state'
import { ConfirmationModalProps } from '../../interfaces'
import { ROUTE_PATH } from 'apps/social-referent/src/routes/enums'

import { SRModal } from '@sr/ui'
import { Button } from '@shared/ui'

import { CheckmarkOutline } from '@carbon/icons-react'

export const ConfirmationModal: React.FC<ConfirmationModalProps> = observer(
  ({ onClose }) => {
    const { id } = useParams<{ id: string }>()
    const { t } = useTranslation()
    const { policy } = useRouteState(ConfirmationModalRouteState, {
      policyId: id,
    })
    const navigate = useNavigate()

    if (!policy || !id) return null

    const dateSelected = getLocalStorageItem('dateSelected')
    const slotsSelected = getLocalStorageItem('slotsSelected')
    
    console.log('🔍 ConfirmationModal Debug:', {
      policy_noDigital: policy.noDigital,
      dateSelected,
      slotsSelected
    })
    
    const date = getDateFormatted(dateSelected, 'DD/MM/YYYY')
    

    let time = ''
    if (policy.noDigital) {
      time = slotsSelected || getDateFormatted(dateSelected, 'HH:mm') || 'Hora no disponible'
    } else {
      time = getDateFormatted(dateSelected, 'HH:mm') || 'Hora no disponible'
    }
    
    console.log('🕐 Final time value:', time)

    const handleContinue = () => {
      navigate(`${ROUTE_PATH.userArea(id)}`)
    }

    return (
      <SRModal onClose={onClose}>
        <div
          className="flex flex-col justify-center items-center gap-4 mb-4 text-primary"
          data-testid="agenda-schedule-modal"
        >
          <CheckmarkOutline size={36} />
          <div className="font-semibold">
            {t('schedule.modal.confirmation.title')}
          </div>
          <div className="text-center">
            {t('schedule.modal.confirmation.userInfo', {
              userName: policy?.fullName,
              srName: policy?.socialReferent?.fullName,
            })}
          </div>
          <div className="flex justify-center items-center gap-2">
            <div>Fecha: {date || 'No disponible'}</div>
            <div>Hora: {time || 'No disponible'}</div>
          </div>
          <Button onClick={handleContinue}>{t('common:continue')}</Button>
        </div>
      </SRModal>
    )
  },
)
